export default __webpack_public_path__ + "static/media/cheese-2.fe483034.png";